import React from 'react';
import clsx from 'clsx';

import styles from './ToggleSwitch.module.scss';

interface ToggleSwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
}

const ToggleSwitch = ({ checked, onChange, disabled = false, className }: ToggleSwitchProps) => {
  const handleClick = () => !disabled && onChange(!checked);

  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      className={clsx(styles.toggleSwitch, checked && styles.checked, disabled && styles.disabled, className)}
      onClick={handleClick}
    >
      <span className={styles.knob} />
    </button>
  );
};

export default ToggleSwitch;
